import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "60a1927e-0537-4f09-b797-a73fa795001a",
    content: "Deterministic model",
    options: {},
  },
  {
    id: "010cf9cf-d315-4585-8bb7-308e99bfa38e",
    content: "Surface scattering possible",
    options: {},
  },
  {
    id: "a6e6a7a7-f8a2-43d4-b37a-20c53f50b24e",
    content: "Linear calculation complexity",
    options: {},
  },
  {
    id: "b91f9a23-c2db-48b7-b412-7801acfc7682",
    content: "No curved surfaces",
    options: {},
  },
  {
    id: "68ca8548-0369-4f16-a92d-e29472ff02b0",
    content: "Precise temporal resolution",
    options: {},
  },
  {
    id: "56ef5dd8-ac11-48a1-870f-f7ab7938c8ac",
    content: "Low temporal resolution",
    options: {},
  },
  {
    id: "895b48d9-5b99-400f-9e48-5c99264f3993",
    content: "Exponential calculation complexity",
    options: {},
  },
  {
    id: "c68f1e04-3239-405b-af10-49ba44f7a838",
    content: "Stochastic errors",
    options: {},
  },
];

const groups = [
  {
    id: "f929bf4e-949f-410c-835f-18c924568fb8",
    content: "ADVANTAGES OF IMAGE SOURCES",
    options: {},
  },
  {
    id: "04651df1-b97c-4609-8b92-a1766cb0582c",
    content: "ADVANTAGES OF RAY TRACING",
    options: {},
  },
  {
    id: "24d86bec-ae0c-4964-8eef-357187b528ac",
    content: "DISADVANTAGES / LIMITATIONS OF IMAGE SOURCES",
    options: {},
  },
  {
    id: "deecd234-445d-4b21-a09d-475b6e2d028a",
    content: "DISADVANTAGES / LIMITATIONS OF RAY TRACING",
    options: {},
  },
];

export const task: Task = {
  id: "599f5b1f-e0df-414a-9930-48f52f952765",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    orientation: "vertical",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "f929bf4e-949f-410c-835f-18c924568fb8",
      itemsId: ["60a1927e-0537-4f09-b797-a73fa795001a", "68ca8548-0369-4f16-a92d-e29472ff02b0"],
    },
    {
      groupId: "04651df1-b97c-4609-8b92-a1766cb0582c",
      itemsId: ["010cf9cf-d315-4585-8bb7-308e99bfa38e", "a6e6a7a7-f8a2-43d4-b37a-20c53f50b24e"],
    },
    {
      groupId: "24d86bec-ae0c-4964-8eef-357187b528ac",
      itemsId: ["b91f9a23-c2db-48b7-b412-7801acfc7682", "895b48d9-5b99-400f-9e48-5c99264f3993"],
    },
    {
      groupId: "deecd234-445d-4b21-a09d-475b6e2d028a",
      itemsId: ["56ef5dd8-ac11-48a1-870f-f7ab7938c8ac", "c68f1e04-3239-405b-af10-49ba44f7a838"],
    },
  ],
};
